import { schema } from 'normalizr'
import { createEntitySchemas } from '../../../utils/normalize'

const processSolicitudeNumbers = entity => ({
  ...entity,
  how_much: Number(entity.how_much)
})

export const SOLICITUDE_EXTRA = 'solicitudeExtras'
export const solicitudeExtraSchema = new schema.Entity(SOLICITUDE_EXTRA, {}, {
  processStrategy: processSolicitudeNumbers
})

export const SOLICITUDE = 'solicitude'
export const solicitudeSchemas = createEntitySchemas(SOLICITUDE, {
  definitions: {
    extra: [solicitudeExtraSchema]
  },
  options: {
    processStrategy: processSolicitudeNumbers
  }
})
